import { DOWNLOAD_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminDownloadService = {
  getAll: (params: any) => requests.get(`${DOWNLOAD_URL}`, params),
  create: (params: any) => requests.post(`${DOWNLOAD_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${DOWNLOAD_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.post(`${DOWNLOAD_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${DOWNLOAD_URL}/${id}`),
};
